let app
let firebase
let db
let analytics
let auth
// let database
let googleProvider
let fbAuth
let fbFireStore
let fbDatabase
let fbAnalytics
let facebookProvider

export const initFirebase = async () => {
  if (firebase) return Promise.resolve(firebase)

  const REACT_APP_FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY
  const REACT_APP_FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
  const REACT_APP_FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID
  const REACT_APP_FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  if (REACT_APP_FIREBASE_API_KEY) {
    firebase = await import('firebase/app')

    const firebaseConfig = {
      apiKey: REACT_APP_FIREBASE_API_KEY,
      authDomain: 'nolanai.firebaseapp.com',
      projectId: 'nolanai',
      storageBucket: 'nolanai.appspot.com',
      messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: REACT_APP_FIREBASE_APP_ID,
      measurementId: REACT_APP_FIREBASE_MEASUREMENT_ID
    }
    app = firebase.initializeApp(firebaseConfig)
  }
}

const initAuth = async () => {
  if (fbAuth) return Promise.resolve(fbAuth)
  fbAuth = await import('firebase/auth')
  googleProvider = new fbAuth.GoogleAuthProvider()
  googleProvider.setCustomParameters({ prompt: 'select_account' })
  auth = fbAuth.initializeAuth(app, {
    persistence: [fbAuth.browserLocalPersistence]
  })
  facebookProvider = new fbAuth.FacebookAuthProvider()
  // Initialize Firebase
  // auth = fbAuth.getAuth(app)
}

const initFireStore = async () => {
  if (fbFireStore) return Promise.resolve(fbFireStore)
  fbFireStore = await import('firebase/firestore')
  db = fbFireStore.getFirestore(app)
  return fbFireStore
}

const initDatabase = async () => {
  if (fbDatabase) return Promise.resolve(fbDatabase)
  fbDatabase = await import('firebase/database')
  // database = fbDatabase.getDatabase(app)
  return fbDatabase
}

export const initAnalytics = async () => {
  if (fbAnalytics) return Promise.resolve(fbAnalytics)
  const ENABLE_ANALYTICS = process.env.REACT_APP_ENABLE_ANALYTICS
  if (ENABLE_ANALYTICS) {
    fbAnalytics = await import('firebase/analytics')
    analytics = fbAnalytics.getAnalytics(app)
  }
}

export const logout = async () => {
  window.localStorage.removeItem('token')
  return fbAuth.signOut(auth)
}

export const logData = async (eventName, data) => {
  await initAnalytics()
  if (!analytics) return console.warn('Analytics not activated')
  fbAnalytics.logEvent(analytics, eventName, data)
}

export const authorize = async () => {
  await initFirebase()
  await initAuth()
  return auth
}

export const getUserData = async () => {
  await initFirebase()
  await initDatabase()
  const user = auth.currentUser
  return user
}

/* export const refreshToken = async () => {
  await initFirebase()
  await initAuth()
  const user = auth.currentUser
  if (user) {
    return user.getIdToken(true)
  }
} */

const initializeForLogin = async () => {
  await initFirebase()
  await initAuth()
  await initFireStore()
}

/**
 * Signs in from a custom token minted by the API's handoff exchange.
 *
 * Used by /auth/callback when a visitor arrives from brand: the resulting
 * session is an ordinary Firebase one, persisted in this origin's localStorage
 * like any other, so refreshes and later visits need no handoff at all.
 *
 * Auth only, not `initializeForLogin`. That helper also pulls in
 * `firebase/firestore`, which is one of the heaviest modules in the SDK and
 * exists for `signInWithGoogle`'s users-collection query — nothing on this path
 * touches it. Waiting for it put a large download in front of the one call
 * standing between the visitor and their dashboard, on the slow connections
 * where the handoff is already the longest part of signing in.
 */
export const signInWithCustomToken = async (customToken) => {
  await initFirebase()
  await initAuth()
  return fbAuth.signInWithCustomToken(auth, customToken)
}

export const signInWithGoogle = async () => {
  try {
    await initializeForLogin()
    const res = await fbAuth.signInWithPopup(auth, googleProvider, fbAuth.browserPopupRedirectResolver)
    const user = res.user
    return fbFireStore.query(fbFireStore.collection(db, 'users'), fbFireStore.where('uid', '==', user.uid))
  } catch (err) {
    console.error(err)
  }
}

// setup facebook provider
export const signInWithFacebook = async () => {
  try {
    await initializeForLogin()
    const res = await fbAuth.signInWithPopup(auth, facebookProvider, fbAuth.browserPopupRedirectResolver)
    const user = res.user
    return fbFireStore.query(fbFireStore.collection(db, 'users'), fbFireStore.where('uid', '==', user.uid))
  } catch (error) {
    console.error(error)
  }
}

export const registerUserWithEmail = async (props) => {
  const { email, password } = props
  await initializeForLogin()
  const { user } = await fbAuth.createUserWithEmailAndPassword(auth, email, password)
  return user
}

export const loginUserWithEmail = async (props) => {
  const { email, password } = props
  await initializeForLogin()
  return fbAuth.signInWithEmailAndPassword(auth, email, password)
}

export const checkEmail = async (email) => {
  await initializeForLogin()
  return fbAuth.fetchSignInMethodsForEmail(auth, email)
}

export const resetPassword = async (email) => {
  await initializeForLogin()
  return fbAuth.sendPasswordResetEmail(auth, email)
}

export const sendVerificationEmail = async () => {
  const user = await getUserData()
  return fbAuth.sendEmailVerification(user)
}
